<shared-modal-container
  headline="Cookies on our website"
  [showCloseButton]="false"
  [isDialogPositionUp]="isDialogPositionUp"
  (closeModal)="disagree()">
  <div class="bg-light px-4 pb-4 w-100">
    <div class="text-14 mb-3">
      We use some necessary cookies to make our site work. We'd like to set analytics cookies to understand how you use this app.
    </div>

    @if (showDetails) {
      <span class="text-14 color-primary pt-2 bold-800 pointer mb-2" (click)="setShowDetails(false)"> Hide details </span>
    } @else {
      <span class="text-14 color-primary pt-2 bold-800 pointer" (click)="setShowDetails(true)"> More details </span>
    }

    <div class="mb-3">
      <ul class="text-14" [@growShrink]="showDetails ? 'visible' : 'hidden'">
        <li class="mb-2">
          <b>Necessary Cookies:</b> These are essential for basic site functions, such as keeping you logged in. Our application cannot work
          without them.
        </li>
        <li>
          <b>Analytics Cookies:</b> With your permission, we use cookies from Google and Fullstory to collect data that helps us understand
          how you use our site and to improve our services.
        </li>
      </ul>
    </div>

    <div class="text-14">
      You can find a detailed list of cookies and their purpose in our
      <a class="color-primary bold-600 pointer" [routerLink]="['/', paths.COOKIE_POLICY]" target="_blank"> Cookie Policy </a>. Please choose
      your preference below.
    </div>

    <div class="flex-column p-3 gap-3">
      <button pButton class="m-a p-button p-button-primary p-button-outline centered w-100" (click)="agree()">Accept All</button>
      <button pButton class="m-a p-button p-button-outline centered w-100" (click)="disagree()">Accept Only Necessary</button>
    </div>
  </div>
</shared-modal-container>
